module.exports = __webpack_public_path__ + "static/media/S6_04.cfdc6a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE6strobe/S6_04.png
// module id = 206
// module chunks = 0